import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useFeatures } from "@/context/FeaturesContext";

export default function ClinicModuleGate({ moduleKey, children }) {
  const { moduleLoading, canAccessModule } = useFeatures();

  if (moduleLoading) {
    return (
      <div className="rounded-xl border border-slate-200 bg-white p-8 text-center text-sm text-slate-500">
        <Loader2 className="mr-2 inline h-4 w-4 animate-spin" />
        Checking clinic permissions...
      </div>
    );
  }

  if (!canAccessModule(moduleKey)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
